

























































































































import { Component, Vue } from 'vue-property-decorator';
import { Device } from '../classes/device';
import { DeviceApi } from '../api/device';
import { DeviceVm } from '../classes/deviceVm';
import { DeviceStatus } from '../enums/deviceStatus';
import AppMessage from 'modules/core/models/appMessage';
import { ElTable } from 'element-ui/types/table';
import { ProfileApi } from 'modules/profile/api/profile';
import { Subscription } from 'modules/profile/classes/subscription';

@Component
export default class List extends Vue {
  public tableColumns: any[] = [];
  public tableData: DeviceVm[] = [];
  public loading: boolean = false;
  public editModeLoading: boolean = false;
  public editModeFields: any = {};
  public editGroupIds: any = {};
  public subscription: Subscription;
  private oldPhoneNumber: string = '';
  private api: DeviceApi;
  private profileApi: ProfileApi;

  constructor() {
    super();
    this.api = new DeviceApi();
    this.profileApi = new ProfileApi();
    this.subscription = new Subscription();
  }

  public async created() {
    this.tableColumns = [
      {
        prop: 'email',
        label: this.$t('devices.phoneNumber') + '/' + this.$t('devices.email'),
        sortable: true,
      },
      {
        prop: 'name',
        label: this.$t('devices.name'),
        sortable: true,
      },
      {
        prop: 'deviceGroupList',
        label: this.$t('devices.deviceGroupList'),
        sortable: false,
      },
      {
        prop: 'deviceStatus',
        label: this.$t('devices.deviceStatus'),
        sortable: true,
      },
    ];

    this.refresh();
  }

  public async refresh() {
    this.loading = true;
    this.tableData = await this.api.list();
    this.subscription = await this.profileApi.getSubscription();
    this.loading = false;
  }

  public enableEditMode(prop: string, index: number) {
    if (!this.editModeFields[prop]) {
      this.editModeFields[prop] = [];
    }

    if (this.editModeFields[prop].includes(index) === false) {
      this.editModeFields[prop].push(index);
    }

    if (prop === 'deviceGroupList') {
      this.editGroupIds[index] = this.tableData[index][prop];
    }

    this.rerenderTable();
  }

  public disableEditMode(prop: string, index: number) {
    if (this.editModeFields[prop]) {
      this.editModeFields[prop] = this.editModeFields[prop].filter((item: number) => {
        return item !== index;
      });
    }
    this.rerenderTable();
  }

  public isEditMode(prop: string, index: number) {
    let result = false;

    if (this.editModeFields[prop]) {
      result = (this.editModeFields[prop].includes(index) === true);
    }

    return result;
  }

  public async saveName(index: number) {
    this.editModeLoading = true;
    const record: DeviceVm = this.tableData[index];
    await this.api.updateName(record.phoneNumber, record.name);
    this.disableEditMode('name', index);
    this.editModeLoading = false;
  }

  public async saveGroupIds(index: number) {
    this.editModeLoading = true;
    const newDeviceGroups = this.editGroupIds[index];
    if (!newDeviceGroups.includes('default')) {
      newDeviceGroups.unshift('default');
    }
    const record: DeviceVm = this.tableData[index];
    await this.api.updateGroupIds(record.phoneNumber, newDeviceGroups, record.deviceGroupList);
    record.deviceGroupList = newDeviceGroups;
    this.disableEditMode('deviceGroupList', index);
    this.editModeLoading = false;
  }

  public rerenderTable() {
    /**
     * @TODO: Hack to rerender table - have to provide something better :)
     */
    this.tableData[0].phoneNumber = 'X' + this.tableData[0].phoneNumber;
    this.tableData[0].phoneNumber = this.tableData[0].phoneNumber.substr(1);
  }

  public add() {
    this.$router.push('/devices/add');
  }

  public async activate(phoneNumber: string) {
    this.loading = true;
    try {
      const result = await this.api.updateStatus(phoneNumber, DeviceStatus.ACTIVE);
      if (result) {
        await this.refresh();
        AppMessage.show(this.$t('devices.changeStatusSuccess'), 'success');
      }
    } catch (error) {
      this.loading = false;
    }
    this.loading = false;
  }

  public async disable(phoneNumber: string) {
    this.loading = true;
    try {
      const result = await this.api.updateStatus(phoneNumber, DeviceStatus.INACTIVE);
      if (result) {
        await this.refresh();
        AppMessage.show(this.$t('devices.changeStatusSuccess'), 'success');
      }
    } catch (err) {
      this.loading = false;
    }
    this.loading = false;
  }

  public deleteDevice(phoneNumber: string, email: string) {
    this.$confirm(
      this.$t('devices.deleteText') as string,
      this.$t('devices.deleteTitle', { email }) as string,
      {
        confirmButtonText: this.$t('general.yes') as string,
        cancelButtonText: this.$t('general.no') as string,
        type: 'warning',
        customClass: 'deviceRemoveDialog',
      },
    )
      .then(async () => {
        const result: boolean = await this.api.delete(phoneNumber);
        if (result) {
          await this.refresh();
          AppMessage.show(this.$t('devices.deleteSuccess'), 'success');
        }
      });
  }
}
